import { GlyphPickerBase } from "../common/glyph-picker-base";

export class DefaultMathGlyphPicker extends GlyphPickerBase {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer;
    }
}
//# sourceMappingURL=glyph-picker.js.map
